import { Icons } from '@shared/components/ui';

import type { SurfaceContext } from './chatDockTypes';

/**
 * The dock header's context chip: a small icon + label naming what the dock's
 * conversation is about ("Inbox", "This email", "This card"), followed by the
 * entity's own title when the surface knows it ("This email · Re: Q3 budget").
 * Inherits the muted text colour so the glyph and label read as one unit. The
 * chip truncates rather than wraps so the frame row keeps its single-line
 * height: with a title, the label keeps its width and the title truncates;
 * without one, the label itself truncates.
 */
export function DockContextChip({ context }: { context: SurfaceContext }) {
  const Icon = Icons[context.icon];
  const title = context.title;
  return (
    <span
      data-testid="dock-context-chip"
      className="text-muted-foreground flex min-w-0 items-center gap-1.5 text-xs"
    >
      <Icon size="xs" color="inherit" />
      <span className={title ? 'shrink-0' : 'truncate'}>{context.label}</span>
      {title ? (
        <>
          <span aria-hidden="true">·</span>
          <span data-testid="dock-context-title" className="truncate">
            {title}
          </span>
        </>
      ) : null}
    </span>
  );
}
